export const heroSectionStyles = {
	heroSectionContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: { xs: '28px', lg: '48px' },
		marginX: { xs: '24px', smTab: 'auto' },
	},
	headingTypography: {
		color: 'colors.light3',
		textAlign: 'center',
	},
	createButton: {
		height: '40px',
		width: '220px',
		padding: '0 16px',
		borderRadius: '4px',
		backgroundColor: 'colors.light2',
		textTransform: 'none',
	},
	heroSectionVideosContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: { xs: '12px', smTab: '24px', lg: '32px' },
		width: '100%',
		overflowX: 'auto',
		overflowY: 'hidden',
		maxWidth: '100vw',
		position: 'relative',
		padding: '0 24px',
	},
	videoStyles: {
		borderRadius: '32px',
		objectFit: 'cover',
		width: '100%',
		height: '100%',
	},
	baseVideoContainerStyles: {
		width: {
			xs: '200px',
			xl: '233px',
			xxl: '278px',
		},
		height: {
			xs: '360px',
			xl: '420px',
			xxl: '500px',
		},
	},
};
